import _withProps from "recompose/withProps";
import _shallowEqual from "recompose/shallowEqual";
import _get from "lodash/get";
import _mapValues from "lodash/mapValues";
import _pickBy from "lodash/pickBy";
import _noop from "lodash/noop";
import _forEach from "lodash/forEach";
import _debounce from "lodash/debounce";

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import update from 'immutability-helper';
import { deprecateProps } from '@nextiva/next-ui';
import { Scrollbars } from 'react-custom-scrollbars';
import DataTableHeader from "./DataTableHeader";
import DataTableHeaderProxy from "./DataTableHeaderProxy";
import Gear from "./Gear";
import bodyRenderer from "../helpers/bodyRenderer";
import headerRenderer from "../helpers/headerRenderer";
import rowRenderer from "../helpers/rowRenderer";
import settingsRenderer from "../helpers/settingsRenderer";
import { arrayMove, getFullDisplayPreference } from "../helpers/utils";
import "../styles/all.css";
import { HEADER_ROW_HEIGHT, ROW_HEIGHT, DEFAULT_COLUMN_WIDTH, SELECT_ROW_CHECKBOX_WIDTH, PREVIEW_ICON_WIDTH, ACTIONS_BTN_WIDTH, SPACING_BETWEEN_CONTROLS, CONTROLS_ROW_PADDING } from "../constants";

var DataTable =
/*#__PURE__*/
function (_Component) {
  _inherits(DataTable, _Component);

  function DataTable(props) {
    var _this;

    _classCallCheck(this, DataTable);

    _this = _possibleConstructorReturn(this, (DataTable.__proto__ || Object.getPrototypeOf(DataTable)).call(this, props));

    _initialiseProps.call(_assertThisInitialized(_this));

    var columnWidths = _this.getColumnWidths(props.displayPreferences);

    _this.state = {
      columnWidths: columnWidths,
      rowSelections: _this.getInitialSelectedRows(props.data, props.selectedRows),
      drag: null,
      isTableOverlayShown: false
    };
    return _this;
  }

  _createClass(DataTable, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener('resize', this.debouncedAdjustWidth);
      this.adjustWidth();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.debouncedAdjustWidth);
      this.stopTrackMouse();
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (_shallowEqual(nextProps, this.props)) {
        return;
      }

      if (nextProps.data !== this.props.data || this.props.selectedRows !== nextProps.selectedRows) {
        this.setState({
          rowSelections: this.getInitialSelectedRows(nextProps.data, nextProps.selectedRows)
        });
      }

      if (this.props.displayPreferences !== nextProps.displayPreferences) {
        var columnWidths = this.getColumnWidths(nextProps.displayPreferences, this.state.columnWidths);
        this.setState({
          columnWidths: columnWidths
        });
      }
    }
  }, {
    key: "getColumnWidths",
    value: function getColumnWidths(preferences, currentWidths) {
      return preferences.reduce(function (acc, col) {
        if (col.display) {
          var existing = currentWidths && currentWidths[col.name] && currentWidths[col.name].width;
          acc[col.name] = {
            width: col.width || existing || DEFAULT_COLUMN_WIDTH
          };
        }

        return acc;
      }, {});
    }
  }, {
    key: "getCellRenderers",
    value: function getCellRenderers() {
      var _this2 = this;

      var renderers = {};
      React.Children.forEach(this.props.children, function (column) {
        renderers[column.props.name] = {
          getCellData: column.props.getCellData || _this2.getCellData,
          columnData: column.props.columnData,
          renderer: column.props.cellRenderer,
          className: column.props.className
        };
      });
      return renderers;
    }
  }, {
    key: "getTableBodyStyle",
    value: function getTableBodyStyle() {
      var _props = this.props,
          data = _props.data,
          isLoading = _props.isLoading;

      if (!data.length || isLoading) {
        return {
          tableLayout: 'auto'
        };
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _state = this.state,
          columnWidths = _state.columnWidths,
          rowSelections = _state.rowSelections,
          drag = _state.drag,
          isTableOverlayShown = _state.isTableOverlayShown;
      var _props2 = this.props,
          data = _props2.data,
          isLoading = _props2.isLoading,
          onRowClick = _props2.onRowClick,
          renderActions = _props2.renderActions,
          tableMetadata = _props2.tableMetadata,
          disableGear = _props2.disableGear,
          disableSelectAll = _props2.disableSelectAll,
          displayPreferences = _props2.displayPreferences,
          updateDisplayPreferences = _props2.updateDisplayPreferences,
          resizable = _props2.resizable,
          headerRowHeight = _props2.headerRowHeight,
          headerRenderer = _props2.headerRenderer,
          rowRenderer = _props2.rowRenderer,
          emptyRowText = _props2.emptyRowText,
          shouldRenderPreviewIcon = _props2.shouldRenderPreviewIcon,
          onPreviewClick = _props2.onPreviewClick,
          settingsRenderer = _props2.settingsRenderer,
          analytics = _props2.analytics,
          bodyRenderer = _props2.bodyRenderer,
          multi = _props2.multi,
          checkable = _props2.checkable,
          allowSelectionOnRowClick = _props2.allowSelectionOnRowClick;
      var controlsColumnWidth = this.getControlsColumnWidth();
      var children = this.enhanceChildrenWithHandlers();
      var finalClassName = cx('nx-table__outer', {
        'nx-table__outer--theme-analytics': analytics
      });
      var tableWidth = this.getTableWidth();
      var tableHeight = this.calculateTableHeight();
      return React.createElement("div", {
        className: finalClassName,
        ref: function ref(outer) {
          return _this3.outer = outer;
        },
        style: {
          height: tableHeight
        }
      }, React.createElement("div", {
        className: "nx-table__wrapper"
      }, React.createElement(Gear, {
        disableGear: disableGear,
        displayPreferences: displayPreferences,
        updateDisplayPreferences: updateDisplayPreferences,
        headerRowHeight: analytics ? 53 : headerRowHeight,
        settingsRenderer: settingsRenderer,
        tableMetadata: tableMetadata
      }), React.createElement("div", {
        ref: function ref(table) {
          return _this3.table = table;
        },
        className: "nx-table__container",
        style: {
          paddingTop: headerRowHeight + 2
        }
      }, React.createElement("table", {
        ref: function ref(header) {
          return _this3.header = header;
        },
        className: "nx-table nx-table__fixed-header",
        style: {
          width: tableWidth
        }
      }, React.createElement(DataTableHeader, {
        displayPreferences: displayPreferences,
        handleSelectAllRows: this.handleSelectAllRows,
        allRowsSelected: rowSelections['ALL'],
        resizable: resizable,
        handleResize: this.handleResize,
        handleResizeStop: this.handleResizeStop,
        drag: drag,
        handleDragStart: this.handleDragStart,
        columnWidths: columnWidths,
        controlsColumnWidth: controlsColumnWidth,
        hasActions: !!renderActions,
        hasData: data.length > 0,
        checkable: checkable,
        multi: multi,
        disableSelectAll: disableSelectAll,
        headerRowHeight: headerRowHeight,
        headerRenderer: headerRenderer,
        shouldRenderPreviewIcon: shouldRenderPreviewIcon
      }, children)), React.createElement(Scrollbars, {
        renderView: function renderView(_ref) {
          var style = _ref.style,
              props = _objectWithoutProperties(_ref, ["style"]);

          return React.createElement("div", _extends({}, props, {
            className: "nx-table__scrollbars-view",
            style: _objectSpread({}, style, {
              overflowX: 'hidden'
            })
          }));
        },
        renderTrackVertical: function renderTrackVertical(_ref2) {
          var style = _ref2.style,
              props = _objectWithoutProperties(_ref2, ["style"]);

          return React.createElement("div", _extends({}, props, {
            style: _objectSpread({}, style, {
              width: '9px',
              right: '2px',
              bottom: '2px',
              top: '2px',
              borderRadius: '4px'
            })
          }));
        },
        style: {
          width: tableWidth
        },
        renderTrackHorizontal: function renderTrackHorizontal() {
          return React.createElement("div", {
            style: {
              height: '0px'
            }
          });
        }
      }, React.createElement("table", {
        style: this.getTableBodyStyle(),
        ref: function ref(content) {
          return _this3.content = content;
        },
        className: "nx-table nx-table__body"
      }, React.createElement(DataTableHeaderProxy, {
        displayPreferences: displayPreferences,
        columnWidths: columnWidths,
        controlsColumnWidth: controlsColumnWidth,
        hasActions: !!renderActions,
        headerRenderer: headerRenderer,
        shouldRenderPreviewIcon: shouldRenderPreviewIcon,
        checkable: checkable,
        multi: multi,
        ref: function ref(header) {
          return _this3.proxyHeader = header;
        }
      }, children), bodyRenderer({
        data: data,
        rowSelections: rowSelections,
        tableMetadata: tableMetadata,
        displayPreferences: displayPreferences,
        renderActions: renderActions,
        isLoading: isLoading,
        controlsColumnWidth: controlsColumnWidth,
        rowRenderer: rowRenderer,
        emptyRowText: emptyRowText,
        onPreviewClick: onPreviewClick,
        shouldRenderPreviewIcon: shouldRenderPreviewIcon,
        allowSelectionOnRowClick: allowSelectionOnRowClick,
        checkable: checkable,
        multi: multi,
        onRowClick: allowSelectionOnRowClick ? this.handleRowSelectOnRowClick : onRowClick,
        onRowSelect: this.handleRowSelect,
        cellRenderers: this.getCellRenderers(),
        getTableRef: this.getTableRef
      })))), _get(drag, 'current') && React.createElement("div", {
        className: "nx-table__drag",
        style: {
          left: drag.current.x,
          top: drag.current.y
        }
      }, drag.label)), isTableOverlayShown && React.createElement("div", {
        className: "nx-table__overlay"
      }));
    }
  }]);

  return DataTable;
}(Component);

Object.defineProperty(DataTable, "propTypes", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: {
    /** Data to populate the table body */
    data: PropTypes.array.isRequired,

    /** Display preferences to determine which columns to display */
    displayPreferences: PropTypes.array.isRequired,

    /** Columns */
    children: PropTypes.array,
    onRowClick: PropTypes.func,

    /** Cell renderer for Actions component */
    renderActions: PropTypes.func,

    /** Replaces default header renderer */
    headerRenderer: PropTypes.func,

    /** Replaces default row renderer */
    rowRenderer: PropTypes.func,

    /** Replaces default body renderer */
    bodyRenderer: PropTypes.func,
    emptyRowText: PropTypes.string,
    selectedRows: PropTypes.array,
    onSelectionsChange: PropTypes.func,
    resizable: PropTypes.bool,
    onFiltersChange: PropTypes.func,
    onSortChange: PropTypes.func,
    onPreviewClick: PropTypes.func,
    settingsRenderer: PropTypes.func,
    checkable: PropTypes.bool,
    multi: PropTypes.bool,
    analytics: PropTypes.bool,
    allowSelectionOnRowClick: PropTypes.bool,
    fixedHeight: PropTypes.bool,
    headerRowHeight: PropTypes.number,
    rowHeight: PropTypes.number,
    fitWidth: PropTypes.bool
  }
});
Object.defineProperty(DataTable, "defaultProps", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: {
    data: [],
    headerRowHeight: HEADER_ROW_HEIGHT,
    rowHeight: ROW_HEIGHT,
    resizable: true,
    onUpdateColumnWidths: _noop,
    headerRenderer: headerRenderer,
    rowRenderer: rowRenderer,
    bodyRenderer: bodyRenderer,
    emptyRowText: 'No results were found.',
    onPreviewClick: _noop,
    settingsRenderer: settingsRenderer,
    checkable: true,
    multi: true,
    analytics: false,
    allowSelectionOnRowClick: false,
    fixedHeight: true,
    fitWidth: false
  }
});

var _initialiseProps = function _initialiseProps() {
  var _this4 = this;

  Object.defineProperty(this, "getInitialSelectedRows", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: function value(data, selectedRows) {
      var rowSelections = {
        ALL: false
      };

      for (var i = 0; i < data.length; i++) {
        rowSelections[i] = false;
      }

      if (selectedRows) {
        for (var _i = 0; _i < selectedRows.length; _i++) {
          rowSelections[selectedRows[_i]] = true;
        }

        if (selectedRows.length === data.filter(_this4.isNotDisabledRow).length) {
          rowSelections.ALL = true;
        }
      }

      return rowSelections;
    }
  });
  Object.defineProperty(this, "isNotDisabledRow", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: function value(row) {
      return !_get(row, 'rowOptions.disabled');
    }
  });
  Object.defineProperty(this, "handleSelectAllRows", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: function value(event) {
      _this4.handleRowSelect(event, 'ALL');
    }
  });
  Object.defineProperty(this, "handleRowSelectOnRowClick", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: function value(event, row, idx) {
      if (row.rowOptions && row.rowOptions.disabled) {
        return;
      }

      _this4.handleRowSelect(event, idx);
    }
  });
  Object.defineProperty(this, "handleRowSelect", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: function value(event, idx) {
      var newSelectedRows = {};
      var rowSelections = _this4.state.rowSelections;
      var _this4$props = _this4.props,
          data = _this4$props.data,
          multi = _this4$props.multi;

      if (idx === 'ALL') {
        Object.keys(rowSelections).forEach(function (idx) {
          var disabled = !_this4.isNotDisabledRow(data[idx]);
          newSelectedRows[idx] = disabled ? false : !rowSelections['ALL'];
          return newSelectedRows[idx];
        });
      } else if (!multi) {
        newSelectedRows = _defineProperty({}, idx, true);
      } else {
        var _objectSpread2;

        newSelectedRows = _objectSpread({}, rowSelections, (_objectSpread2 = {}, _defineProperty(_objectSpread2, idx, !rowSelections[idx]), _defineProperty(_objectSpread2, "ALL", true), _objectSpread2));
        newSelectedRows['ALL'] = data.filter(_this4.isNotDisabledRow).every(function (row, idx) {
          return newSelectedRows[idx];
        });
      }

      _this4.setState({
        rowSelections: newSelectedRows
      });

      if (_this4.props.onSelectionsChange) {
        var rowsArray = [];

        _forEach(newSelectedRows, function (val, key) {
          if (val && key !== 'ALL') {
            rowsArray.push(Number(key));
          }
        });

        _this4.props.onSelectionsChange(rowsArray.sort(function (a, b) {
          return a - b;
        }));
      }
    }
  });
  Object.defineProperty(this, "getElementWidth", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: function value(el) {
      return el && el.getBoundingClientRect().width || 0;
    }
  });
  Object.defineProperty(this, "adjustWidth", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: function value() {
      if (_this4.content && _this4.header) {
        var width = _this4.getTableWidth();

        _this4.content.parentNode.parentNode.style.width = width;
        _this4.header.style.width = width;
      }
    }
  });
  Object.defineProperty(this, "debouncedAdjustWidth", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: _debounce(this.adjustWidth, 100)
  });
  Object.defineProperty(this, "getControlsColumnWidth", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: function value() {
      var _this4$props2 = _this4.props,
          checkable = _this4$props2.checkable,
          renderActions = _this4$props2.renderActions,
          shouldRenderPreviewIcon = _this4$props2.shouldRenderPreviewIcon,
          analytics = _this4$props2.analytics;
      var controlsColumnWidth = CONTROLS_ROW_PADDING + ACTIONS_BTN_WIDTH;

      if (checkable && renderActions) {
        controlsColumnWidth += SELECT_ROW_CHECKBOX_WIDTH;
        controlsColumnWidth += SPACING_BETWEEN_CONTROLS;
      }

      if (shouldRenderPreviewIcon) {
        controlsColumnWidth += PREVIEW_ICON_WIDTH;
        controlsColumnWidth += SPACING_BETWEEN_CONTROLS;
      }

      if (analytics) return 52;
      return controlsColumnWidth;
    }
  });
  Object.defineProperty(this, "getCellData", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: function value(rowData, name) {
      return rowData[name];
    }
  });
  Object.defineProperty(this, "handleResize", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: function value(name, width) {
      _this4.proxyHeader.handleResize(name, width);
    }
  });
  Object.defineProperty(this, "handleResizeStop", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: function value(name, width) {
      var columnWidths = update(_this4.state.columnWidths, _defineProperty({}, name, {
        $merge: {
          width: width
        }
      }));

      _this4.setState({
        columnWidths: columnWidths
      });

      _this4.props.onUpdateColumnWidths(columnWidths);
    }
  });
  Object.defineProperty(this, "handleDragStart", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: function value(e, _ref3) {
      var name = _ref3.name,
          label = _ref3.label,
          cell = _ref3.cell;
      var displayPreferences = _this4.props.displayPreferences;
      var dragItem = displayPreferences.find(function (item) {
        return item.name === name;
      });
      var isDragAllowed = getFullDisplayPreference(dragItem).configurable;
      e && e.preventDefault();

      if (isDragAllowed) {
        _this4.setState({
          drag: _objectSpread({
            name: name,
            label: label,
            cell: cell
          }, _this4.getColumnBoundaries(cell))
        });

        _this4.startTrackMouse();
      }
    }
  });
  Object.defineProperty(this, "handleDragEnd", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: function value(e) {
      e && e.preventDefault();

      _this4.stopTrackMouse();

      _this4.setState({
        drag: null
      });
    }
  });
  Object.defineProperty(this, "handleMouseMove", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: function value(e) {
      var x = e.clientX,
          y = e.clientY;
      var drag = _this4.state.drag;
      var newState = {
        drag: _objectSpread({}, drag, {
          current: {
            x: x,
            y: y
          }
        })
      }; // move

      var shouldMoveLeft = x < drag.left;
      var shouldMoveRight = x > drag.right;

      if (shouldMoveLeft || shouldMoveRight) {
        if (shouldMoveLeft) {
          _this4.moveColumn(-1);
        } else if (shouldMoveRight) {
          _this4.moveColumn(1);
        }

        newState.drag = _objectSpread({}, newState.drag, _this4.getColumnBoundaries(drag.cell));
      }

      _this4.setState(newState);
    }
  });
  Object.defineProperty(this, "getColumnBoundaries", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: function value(el) {
      var rect = el.getBoundingClientRect();
      return {
        left: rect.x | 0,
        right: rect.x + rect.width | 0
      };
    }
  });
  Object.defineProperty(this, "moveColumn", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: function value(direction) {
      var drag = _this4.state.drag;
      var _this4$props3 = _this4.props,
          list = _this4$props3.displayPreferences,
          updateDisplayPreferences = _this4$props3.updateDisplayPreferences;
      var from = list.findIndex(function (item) {
        return item.name === drag.name;
      });
      var to = -1;
      if (!direction || from === -1) return;

      if (direction > 0) {
        // move right
        to = list.findIndex(function (item, i) {
          item = getFullDisplayPreference(item);
          return item.display && item.configurable && i > from;
        });

        if (to > -1) {
          updateDisplayPreferences(arrayMove(list, from, to));
        }
      } else {
        // move left
        list.slice(0, from).forEach(function (item, i) {
          item = getFullDisplayPreference(item);
          if (item.display && item.configurable) to = i;
        });

        if (to > -1) {
          updateDisplayPreferences(arrayMove(list, from, to));
        }
      }
    }
  });
  Object.defineProperty(this, "startTrackMouse", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: function value() {
      document.addEventListener('mousemove', _this4.handleMouseMove);
      document.addEventListener('mouseup', _this4.handleDragEnd);
    }
  });
  Object.defineProperty(this, "stopTrackMouse", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: function value() {
      document.removeEventListener('mousemove', _this4.handleMouseMove);
      document.removeEventListener('mouseup', _this4.handleDragEnd);
    }
  });
  Object.defineProperty(this, "enhanceChildrenWithHandlers", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: function value() {
      return React.Children.map(_this4.props.children, function (column) {
        return React.cloneElement(column, {
          analytics: _this4.props.analytics,
          onResetAll: _this4.handleAllFiltersReset,
          onFilterChange: _this4.handleFilterChange(column.props.name),
          onSortChange: _this4.handleSortChange(column.props.name),
          onToggleFilter: _this4.onToggleFilter
        });
      });
    }
  });
  Object.defineProperty(this, "onToggleFilter", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: function value(isOpen) {
      // open without delay, hide with delay.
      // fixes bug for iPad when click goes through overlay,
      // when it is removed before click event has finished its propagation. (NUI-534)
      var delay = isOpen ? 0 : 300;
      setTimeout(function () {
        _this4.setState({
          isTableOverlayShown: isOpen
        });
      }, delay);
    }
  });
  Object.defineProperty(this, "getChildrenFilters", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: function value() {
      return React.Children.toArray(_this4.props.children).reduce(function (acc, column) {
        var _column$props = column.props,
            name = _column$props.name,
            filterData = _column$props.filterData;
        acc[name] = filterData;
        return acc;
      }, {});
    }
  });
  Object.defineProperty(this, "handleFilterChange", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: function value(key) {
      return function (filterData) {
        var allFilterData = _this4.getChildrenFilters();

        var state = _objectSpread({}, allFilterData, _defineProperty({}, key, filterData));

        var newState = _mapValues(_pickBy(state, function (data) {
          return data && data.operator && data.values && data.values.length > 0;
        }), function (filter, key) {
          return _objectSpread({}, filter, {
            key: key
          });
        });

        return _this4.props.onFiltersChange(newState);
      };
    }
  });
  Object.defineProperty(this, "handleAllFiltersReset", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: function value() {
      _this4.props.onFiltersChange({});
    }
  });
  Object.defineProperty(this, "handleSortChange", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: function value(key) {
      return function (order) {
        _this4.props.onSortChange({
          key: key,
          order: order
        });
      };
    }
  });
  Object.defineProperty(this, "getTableWidth", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: function value() {
      var _this4$props4 = _this4.props,
          fitWidth = _this4$props4.fitWidth,
          disableGear = _this4$props4.disableGear;
      if (!_this4.table) return undefined;

      var visibleWidth = _this4.getElementWidth(_this4.table);

      var tableWidth = Object.keys(_this4.state.columnWidths).reduce(function (width, key) {
        return width + _this4.state.columnWidths[key].width;
      }, 0);

      var tableWithOffsetWidth = tableWidth + _this4.getOffset();

      var finalTableWidth = fitWidth && disableGear ? tableWithOffsetWidth : Math.max(tableWithOffsetWidth, visibleWidth);
      return "".concat(finalTableWidth, "px");
    }
  });
  Object.defineProperty(this, "getOffset", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: function value() {
      var offset = _this4.getControlsColumnWidth();

      if (!_this4.props.disableGear) offset += 40;
      return offset;
    }
  });
  Object.defineProperty(this, "calculateTableHeight", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: function value() {
      var result = '100%';
      var _this4$props5 = _this4.props,
          minHeight = _this4$props5.minHeight,
          maxHeight = _this4$props5.maxHeight,
          headerRowHeight = _this4$props5.headerRowHeight,
          rowHeight = _this4$props5.rowHeight,
          data = _this4$props5.data,
          analytics = _this4$props5.analytics,
          fixedHeight = _this4$props5.fixedHeight;

      if (Array.isArray(data)) {
        var finalHeaderRowHeight = analytics ? 54 : headerRowHeight;
        var finalRowHeight = analytics ? 96 : rowHeight; // rowHeight + 1 --> 1 its additional border height
        // +3 --> for additional borders in headers and somewhere else
        // TODO: fix it

        var baseRowHeight = data.length * (finalRowHeight + 1);
        var realHeight = baseRowHeight + finalHeaderRowHeight + 3;

        if (!fixedHeight) {
          result = realHeight;
        }

        if (maxHeight) {
          result = Math.max(minHeight, Math.min(maxHeight, realHeight));
        }
      }

      return result;
    }
  });
  Object.defineProperty(this, "getTableRef", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: function value() {
      return _this4.outer;
    }
  });
};

export default _withProps(function (props) {
  // remove `disableCheckboxes` in 4.x
  if (typeof props.disableCheckboxes !== 'undefined') {
    return {
      checkable: !props.disableCheckboxes
    };
  }

  return {};
})(deprecateProps(['disableCheckboxes'])(DataTable));